document.querySelectorAll('modal-opener').forEach((opener) => {
  opener.addEventListener('click', () => {
    const modalSelector = opener.dataset.modal;
    const modal = document.querySelector(modalSelector);
    if (modal) {
      modal.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
    }
  });
});

document.addEventListener('click', (e) => {
  if (
    e.target.closest('.modal-close') ||
    e.target.closest('.product-media-modal__toggle')
  ) {
    const modal = e.target.closest('product-modal');
    if (modal) {
      modal.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    }
  }
});

document.addEventListener('click', (event) => {
  const featuredFilterChip = event.target.closest('.collection-model-filter-bar__chip');

  if (!featuredFilterChip || featuredFilterChip.classList.contains('is-disabled')) {
    return;
  }

  const paramName = featuredFilterChip.dataset.featuredFilterParam;
  const paramValue = featuredFilterChip.dataset.featuredFilterValue;

  if (!paramName || typeof FacetFiltersForm === 'undefined') {
    return;
  }

  const desktopInputs = Array.from(document.querySelectorAll('#FacetFiltersForm input')).filter((input) => {
    return !input.disabled;
  });
  const mobileInputs = Array.from(document.querySelectorAll('#FacetFiltersFormMobile input')).filter((input) => {
    return !input.disabled;
  });
  const candidateInputs = [...desktopInputs, ...mobileInputs];
  const matchingInput = candidateInputs.find((input) => {
    return input.name === paramName && input.value === paramValue;
  });

  if (!matchingInput) {
    return;
  }

  event.preventDefault();
  matchingInput.click();
});
